import { Component } from '@angular/core';
import { BaseFormDirective } from 'src/app/directives/base-form.directive';

@Component({
  selector: 'app-state-form',
  templateUrl: './state-form.component.html',
  styleUrls: ['./state-form.component.sass']
})
export class StateFormComponent extends BaseFormDirective {
  override title = 'MENU.STATES'
  override form = {
    name_: null,
    state_id: null
  }
  path = 'state'




  override getItemEdit() {
    this.editService = this.data.core.stateUnique(this.editId)
    super.getItemEdit()
  }

  override setSubmitMethods(): void {
    this.postService = this.data.core.stateCreate(this.formSanitized)
    this.putService = this.data.core.stateUpdate(this.editId, this.formSanitized)
  }
}
